import { Grid } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { FunctionComponent, ReactNode } from 'react';
import { CalendarFilter } from 'components/UI';
import { faUsers } from '@fortawesome/pro-light-svg-icons';
import Filter from 'components/UI/Filter';
import { Option, Period } from '@spike/model';

interface HeaderProps {
    period: Period;
    staffOptions: Array<Option<number>>;
    selectedStaffIds: Array<number>;
    className?: string;
    exportButton?: ReactNode;
    onChangePeriod(period: Period): void;
    onStaffChange(staffs: Array<number>): void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        bar: {
            gap: 20,
            display: 'flex',
            borderRadius: 12,
            padding: '12px 16px',
            backgroundColor: '#F1F1F1',

            [theme.breakpoints.down('sm')]: {
                justifyContent: 'space-between'
            },
            [theme.breakpoints.up('md')]: {
                marginTop: 24,
                padding: '14px 20px'
            }
        },
        calendar: {
            '& > button': {
                'height': 39,
                'borderRadius': 30,
                'color': '#222222',
                'border': '2px solid #222222',
                'backgroundColor': 'white',

                [theme.breakpoints.up('md')]: {
                    height: 43
                },

                '&:hover': {
                    backgroundColor: 'white'
                }
            }
        },
        staffFilter: {
            'height': 39,
            'paddingTop': 0,
            'paddingLeft': 13,
            'paddingRight': 13,
            'paddingBottom': 0,
            'borderRadius': 30,
            'backgroundColor': '#000000',
            'border': '2px solid #000000',

            [theme.breakpoints.down('sm')]: {
                'maxWidth': '50%',

                '& .MuiButton-label': {
                    '& span:not(.MuiButton-startIcon)': {
                        width: '100%',

                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    }
                }
            },
            [theme.breakpoints.up('md')]: {
                height: 43,
                backgroundColor: '#FFFFFF'
            },

            '& button': {
                [theme.breakpoints.down('sm')]: {
                    width: '100%'
                }
            },
            '& svg': {
                marginRight: 4
            },
            '& .MuiButton-label': {
                color: '#fff',

                [theme.breakpoints.up('md')]: {
                    color: '#000'
                }
            },
            '& .MuiButton-outlined': {
                border: 'none !important'
            },
            '& .MuiButton-startIcon': {
                marginRight: 6
            }
        }
    })
);

export const Header: FunctionComponent<HeaderProps> = props => {
    const classes = useStyles();

    const onStaffChange = (ids: Array<number | undefined>) => {
        const staffIds: number[] = ids.filter((id): id is number => id !== undefined);

        const allStaffSelected = props.staffOptions.length > 0 && props.staffOptions.length === staffIds.length;

        props.onStaffChange(allStaffSelected ? [] : staffIds);
    };

    return (
        <Grid
            container
            className={props.className}
        >
            <Grid
                container
                xs={12}
                className={classes.bar}
            >
                <CalendarFilter
                    hideUpcoming
                    disableFuture
                    showLabelOnMobile
                    hideAllTime
                    dropdownAlignment="left"
                    period={{
                        from: props.period.from,
                        to: props.period.to
                    }}
                    optionSelected="This month"
                    onChange={period => props.onChangePeriod({ ...period })}
                    className={classes.calendar}
                />
                <Filter
                    label="Staff"
                    icon={faUsers}
                    selectedIds={props.selectedStaffIds}
                    options={props.staffOptions}
                    onSelect={onStaffChange}
                    showLabelOnMobile={true}
                    className={classes.staffFilter}
                />
                {props.exportButton}
            </Grid>
        </Grid>
    );
};

export default Header;
